import React from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '@/contexts/AuthContext';
import { isForeignCompany, toEur, rwLabel } from '@/constants/remoteWork';

export const EurHint = ({ cve, className = '', force = false, testId = 'eur-hint' }) => {
  const { user } = useAuth();
  const { i18n } = useTranslation();
  if (!force && !isForeignCompany(user)) return null;
  return (
    <span className={`block text-xs font-medium opacity-80 ${className}`} data-testid={testId}>
      ≈ {toEur(cve).toLocaleString('pt-PT')} € ({rwLabel(i18n.language, 'approxEur')})
    </span>
  );
};
